import React, { useRef, useState, useEffect } from "react";
import { Button, Modal } from "@heroui/react";

interface SmsStepProps {
  onBack: () => void;
  onResend: () => void;
  onSubmit: (code: string) => void;
  isConfirming: boolean;
  isResending: boolean;
}

export const SmsStep: React.FC<SmsStepProps> = ({
  onBack,
  onResend,
  onSubmit,
  isConfirming,
  isResending,
}) => {
  const [code, setCode] = useState(["", "", "", ""]);
  const refs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
  ];

  useEffect(() => {
    refs[0].current?.focus();
  }, []);

  const resetCode = () => {
    setCode(["", "", "", ""]);
    refs[0].current?.focus();
  };

  const handleChange = (i: number, val: string) => {
    const ch = val.replace(/\D/g, "").slice(-1);
    const next = [...code];
    next[i] = ch;
    setCode(next);
    if (ch && i < 3) refs[i + 1].current?.focus();
  };

  const handleKeyDown = (
    i: number,
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (e.key === "Backspace" && !code[i] && i > 0) {
      refs[i - 1].current?.focus();
    }
  };

  const filled = code.every((c) => c !== "");

  return (
    <>
      <Modal.Header className="pm-modal__header">
        <Modal.Heading className="pm-modal__heading">
          Подтверждение
        </Modal.Heading>
        <p className="pm-modal__subtext">
          Введите 4-значный код из SMS, отправленного на ваш номер
        </p>
      </Modal.Header>
      <Modal.Body className="pm-modal__body pm-modal__body--center">
        <div className="pm-sms-inputs">
          {code.map((val, i) => (
            <input
              key={i}
              ref={refs[i]}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={val}
              onChange={(e) => handleChange(i, e.target.value)}
              onKeyDown={(e) => handleKeyDown(i, e)}
              className={`pm-sms-input ${val ? "pm-sms-input--filled" : ""}`}
              aria-label={`Цифра ${i + 1}`}
              disabled={isConfirming}
            />
          ))}
        </div>
        <p className="pm-sms-hint">
          Не получили код?{" "}
          <button
            className="pm-sms-resend"
            type="button"
            disabled={isResending}
            onClick={() => {
              onResend();
              resetCode();
            }}
          >
            {isResending ? "Отправка..." : "Отправить повторно"}
          </button>
        </p>
      </Modal.Body>
      <Modal.Footer className="pm-modal__footer">
        <Button variant="tertiary" isDisabled={isConfirming} onPress={onBack}>
          Назад
        </Button>
        <Button
          variant="primary"
          isDisabled={!filled || isConfirming}
          isPending={isConfirming}
          onPress={() => onSubmit(code.join(""))}
        >
          Подтвердить
        </Button>
      </Modal.Footer>
    </>
  );
};

SmsStep.displayName = "SmsStep";
